
  const setUserId = (id) => {
    localStorage.setItem("userId", id);
  };
  
  const getUserId = () => {
    const id = localStorage.getItem("userId");
    if (id !== null && id !== undefined) {
      return id;
    } else {
      return null;
    }
  };
  const removeUserId = () => {
    localStorage.removeItem("userId");
  };
  
  const userInfo= { setUserId, getUserId, removeUserId };

   export default userInfo;
  